import axios from 'axios';
import Cookies from 'js-cookie';
import Utils from '../../common/scripts/utils';

class Favorite {
    constructor() {
        this.targetSelector = '.j-favorite-btn';
        this.activeClass = 'is-active';
    }

    /**
     * Инициализирует модуль
     * @param {object} options - настройки
     */
    init(options) {
        this.elem = options.elem;
        this.isFavoritePage = options.isFavoritePage || false;

        this._getElements();
        this._bindContext();
        this._bindEvents();
        this._setResults();
    }

    /**
     * Получает элементы
     * @private
     */
    _getElements() {
        this.targets = Array.from(this.elem.querySelectorAll(this.targetSelector));
        this.reset = this.elem.querySelector('.j-favorite-reset');
        this.header = document.querySelector('.j-header-favorite');
        this.counter = document.querySelector('.j-favorite-count');
        this.rows = Array.from(this.elem.querySelectorAll('.parametric-row'));
        this.cards = Array.from(this.elem.querySelectorAll('.parametric-card'));
        this.cookie = Cookies.get('fav_id_counts');
    }

    /**
     * Привязывает контекст
     * @private
     */
    _bindContext() {
        this._onClick = this._onClick.bind(this);
        this._resetAll = this._resetAll.bind(this);
    }

    /**
     * Метод навешивает обработчики событий
     * @private
     */
    _bindEvents() {
        this.targets.forEach((target) => {
            if (!target.bindClick) {
                target.addEventListener('click', this._onClick);
                target.bindClick = true;
            }
        });

        if (this.reset) {
            this.reset.addEventListener('click', this._resetAll);
        }

        // if (this.cookie && document.querySelector('.j-favorite-flat')) {
        //     const flatBtn = document.querySelector('.j-favorite-btn');
        //     const flatBtnId = flatBtn.dataset.id;
        //
        //     if (this.cookie.match(flatBtnId)) {
        //         flatBtn.classList.add('is-active');
        //     }
        // }

        if (this.cookie && this.isFavoritePage) {
            this.elem.classList.remove('is-empty');
        }

        this.rows.forEach((item) => {
            item.addEventListener('click', (event) => {
                if (!event.target.classList.contains('j-favorite-btn')) {
                    window.location.href = event.target
                        .closest('.parametric-row').dataset.href;
                }
            });
        });

        this.cards.forEach((item) => {
            item.addEventListener('click', (event) => {
                if (event.target.classList.contains('j-favorite-btn')) {
                    return;
                }

                window.location.href = event.target
                    .closest('.parametric-card').attribute('href');
            });
        });
    }

    /**
     * Метод записывает данные в попап для отправки
     * @private
     */
    _popupEvents() {
        const btnContainer = document.querySelector('.favorite-callback__btn');
        const callbackBtn = btnContainer.querySelector('.j-popup-callback-call');
        const linksArray = [];

        this.counter.textContent = this.cookie.replace(/\s/g, '').split(',').length;

        callbackBtn.addEventListener('click', () => {
            this.rows.forEach((item) => {
                linksArray.push(item.dataset.href);
            });

            setTimeout(() => {
                const popup = document.querySelector('.is-open');
                const urlHidden = popup.querySelector('input[name="urls"]');

                urlHidden.value = linksArray;
            }, 500);
        });
    }

    /**
     * Метод записывает в массив с результатами данные из куки
     * @private
     */
    _setResults() {
        this.results = [];

        if (this.cookie) {
            this.results = this.cookie.replace(/\s/g, '').split(',');
        }
    }

    /**
     * Событие при клике на кнопку
     * @param {Object} event - объект события
     * @private
     */
    _onClick(event) {
        event.preventDefault();
        event.stopPropagation();

        this.target = event.target.closest(this.targetSelector);
        this.id = String(this.target.dataset.id);
        this.type = String(this.target.dataset.type);

        if (this.target.classList.contains(this.activeClass)) {
            // this._removeActive();
            this._send('remove', this.id, this.type);
        } else {
            this._send('add', this.id, this.type);
            // this._setActive();
        }

        // this._setCookie();
        // this._setButtonState();
    }

    /**
     * Метод подготавливает форм-дату для отправки
     * @param {string} action - add - добавление, remove - удаление
     * @param {string} id - id элемента
     * @param {string} type - тип элемента
     * @private
     */
    _send(action, id, type) {
        this.formData = new FormData();

        if (action === 'remove') {
            this._removeActive();
        }

        if (action === 'add') {
            this._setActive();
        }

        if (action === 'removeAll') {
            this._removeAllItems();
        }

        this.formData.append('id', id);
        this.formData.append('action', action);
        this.formData.append('type', type);
        this.formData.append('event', 'favorite');

        axios.post('/ajax/api.php', this.formData)
            .then((response) => {
                const status = response.data.request.status;

                if (status) {
                    this._setCookie();
                    this._setButtonState();
                } else {
                    throw new Error('Ошибка на сервере');
                }
            })
            .catch((err) => {
                console.error(err);
            });
    }

    /**
     * Событие удаления всего избранного
     * @param {object} event - объект события
     * @private
     */
    _resetAll(event) {
        event.preventDefault();

        this.results = [];
        this._setCookie();

        if (this.isFavoritePage) {
            this._send('removeAll', 'all', 'all');

            // this._removeAllItems();
        }
    }

    /**
     * Устанавливает кнопке активный класс и записывает id в массив с результатами
     * @private
     */
    _setActive() {
        this.target.classList.add(this.activeClass);
        this._setResults();
        this.results.push(this.id);
    }

    /**
     * Метод убирает активный класс и возвращает новый массив с результатами без того, по которому произошло событие
     * @private
     */
    _removeActive() {
        this.target.classList.remove(this.activeClass);
        this._setResults();
        this.results = this.results.filter((item) => {
            return item !== this.id;
        });

        if (this.isFavoritePage) {
            this._removeItem();
        }
    }

    /**
     * Удаляет карточку из списка избранного
     * @private
     */
    _removeItem() {
        const rows = Array.from(this.elem.querySelectorAll(`.parametric-row[data-id="${this.id}"]`));
        const cards = Array.from(this.elem.querySelectorAll(`.parametric-card[data-id="${this.id}"]`));

        rows.forEach((row) => {
            Utils.removeElement(row.closest('.parametric-row') || row);
        });

        cards.forEach((card) => {
            Utils.removeElement(card.closest('.parametric-row') || card);
        });

        this._changeCount();
    }

    /**
     * Удаляет все квартиры из списка
     * @private
     */
    _removeAllItems() {
        this.rows.forEach((row) => {
            Utils.removeElement(row.closest('.parametric-row') || row);
        });

        this.cards.forEach((card) => {
            Utils.removeElement(card.closest('.parametric-row') || card);
        });

        this._showEmptyContent();
    }

    /**
     * Метод заменяет заголовок избранного при удалении элементов
     * @private
     */
    _changeCount() {
        if (!this.counter) {
            return;
        }

        if (this.results.length > 0) {
            this.counter.textContent = this.results.length;
        } else {
            this._showEmptyContent();
        }
    }

    /**
     * Метод показывает скрытый блок с контентом для пустого избранного
     * @private
     */
    _showEmptyContent() {
        const hiddenClass = 'is-empty';

        this.elem.classList.add(hiddenClass);
        this.header.classList.remove('is-active');
    }

    /**
     * Записывает массив с результатами в куки
     * @private
     */
    _setCookie() {
        Cookies.set('fav_id_counts', this.results.toString());
    }

    /**
     * Меняет состояние кнопки избранного в хедере
     * @private
     */
    _setButtonState() {
        const isActive = this.results.length > 0;

        this.header.classList.toggle(this.activeClass, isActive);
        this.header.dataset.cnt = this.results.length;
    }
}

export default Favorite;
